import { gql } from "@apollo/client";

export const SET_PAYMENT_METHOD = gql`
  mutation SetPaymentMethodOnCart($cart_id: String!) {
    setPaymentMethodOnCart(
      input: { cart_id: $cart_id, payment_method: { code: "hostedpayment" } }
    ) {
      cart {
        selected_payment_method {
          code
          title
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const PLACE_ORDER = gql`
  mutation PlaceOrder($cart_id: String!) {
    placeOrder(input: { cart_id: $cart_id }) {
      order {
        order_number
        __typename
      }
      __typename
    }
  }
`;

export const CANCEL_ORDER = gql`
  mutation CancelOrder($order_id: String!) {
    cancelOrderAndRestoreQuote(input: { order_id: $order_id }) {
      cart {
        id
        total_quantity
        __typename
      }
      __typename
    }
  }
`;
